import "./assets/main.css";
import "@/assets/styles/index.scss";
// 2. 引入组件样式
import "vant/lib/index.css";
// import VConsole from 'vconsole';
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Spinner from '@ventralnet/vue3-spinkit'
import * as Sentry from '@sentry/vue'
import SafeAreaAdapter from 'safe-area-adapter'
import { ref } from 'vue'
import { Swipe, SwipeItem,DatePicker, List, BackTop, Form, Loading,Checkbox, CheckboxGroup, Popup, DropdownMenu, Icon,  DropdownItem, Popover, Field, CellGroup,Picker,Uploader, RadioGroup, Radio   } from "vant";

const app = createApp(App);

Sentry.init({
    app,                          // 传入 Vue app 实例
    dsn: 'https://a0b9c14956e2d37548e8bad7e8383a35@o4511210378756096.ingest.us.sentry.io/4511210383343616',  // 在 Sentry 项目设置中获取

    // 性能监控采样率，生产环境建议调低（如 0.2），开发时可设为 1.0
    tracesSampleRate: 1.0,

    // 会话回放采样率：10% 的会话录制，发生错误时 100% 录制
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,


    integrations: [
        Sentry.browserTracingIntegration({ router }),  // 路由性能追踪
        Sentry.replayIntegration(),                    // 会话回放
    ],
})
// SafeAreaAdapter.init({
//     debug: true,                    // 是否开启调试模式
//     defaultSafeAreaHeight: 34,       // 默认底部安全区域高度
//     maskColor: '#ffffff'             // 遮罩层背景色
// })

// const vConsole = new VConsole();
app.component('Spinner', Spinner)
app.use(router);
app.use(Swipe);
app.use(SwipeItem);
app.use(Radio);
app.use(RadioGroup);
app.use(List);
app.use(Checkbox);
app.use(Form);
app.use(CheckboxGroup);
app.use(BackTop);
app.use(Loading);
app.use(Popup);
app.use(Field);
app.use(Uploader);
app.use(Picker);
app.use(CellGroup);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Icon);
app.use(DatePicker);
app.use(Popover);

app.mount("#app");
